/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs'

const $nsid = 'app.bsky.contact.defs'

type $nsid = typeof $nsid

export { $nsid }

type SyncStatus = {
  $type?: 'app.bsky.contact.defs#syncStatus'

  /**
   * Last date when contacts where imported.
   */
  syncedAt: l.DatetimeString

  /**
   * Number of existing contact matches resulting of the user imports and of their imported contacts having imported the user. Matches stop being counted when the user either follows the matched contact or dismisses the match.
   */
  matchesCount: number
}

export type { SyncStatus }

const syncStatus = /*#__PURE__*/ l.typedObject<SyncStatus>(
  $nsid,
  'syncStatus',
  /*#__PURE__*/ l.object({
    syncedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    matchesCount: /*#__PURE__*/ l.integer({ minimum: 0 }),
  }),
)

export { syncStatus }

/** A stash object to be sent via bsync representing a notification to be created. */
type Notification = {
  $type?: 'app.bsky.contact.defs#notification'

  /**
   * The DID of who this notification should go to.
   */
  to: l.DidString

  /**
   * The DID of who this notification comes from.
   */
  from: l.DidString
}

export type { Notification }

/** A stash object to be sent via bsync representing a notification to be created. */
const notification = /*#__PURE__*/ l.typedObject<Notification>(
  $nsid,
  'notification',
  /*#__PURE__*/ l.object({
    to: /*#__PURE__*/ l.string({ format: 'did' }),
    from: /*#__PURE__*/ l.string({ format: 'did' }),
  }),
)

export { notification }

/** Associates a profile with the positional index of the contact import input in the call to `app.bsky.contact.importContacts`, so clients can know which phone caused a particular match. */
type MatchAndContactIndex = {
  $type?: 'app.bsky.contact.defs#matchAndContactIndex'

  /**
   * Profile of the matched user.
   */
  match: ActorDefs.ProfileView

  /**
   * The index of this match in the import contact input.
   */
  contactIndex: number
}

export type { MatchAndContactIndex }

/** Associates a profile with the positional index of the contact import input in the call to `app.bsky.contact.importContacts`, so clients can know which phone caused a particular match. */
const matchAndContactIndex = /*#__PURE__*/ l.typedObject<MatchAndContactIndex>(
  $nsid,
  'matchAndContactIndex',
  /*#__PURE__*/ l.object({
    match: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    contactIndex: /*#__PURE__*/ l.integer({ maximum: 999, minimum: 0 }),
  }),
)

export { matchAndContactIndex }
